import { CertificatePageNumber, ContactPageNumber, ExteriorPageNumber, ImageCapturePageNumber, LandingPageNumber } from '../../../constants'
import { getPageHierarchy, PAGE_NUMBER_TO_ID } from './pageId'
import { getPageId } from './pageId'
import { pickBy } from 'lodash'
import { isConditionPage } from './pageMaps'
import { getAkamaiZipCode } from '../../../utils/getAkamaiZipCode/getAkamaiZipCode'

const resetCDL = () => {
  window.coxAutoDataLayer.push({
    page: undefined,
    user: undefined,
    ico: undefined,
    peSnapshotId: '',
    vehicle: undefined,
    client: undefined,
    product: undefined
  })
}

const pageHierarchy = (dataLayer, isPageView) => {
  const { pageInfo } = dataLayer
  const linkName = pageInfo.linkName
  const isNextFromImage = linkName?.startsWith('pic1_') && !isPageView

  const isConditionComponentTabLoad = linkName?.startsWith('ico_condition') || linkName?.startsWith('button::subnav::') || linkName === 'button::nav::exterior'

  const isModalSkip = pageInfo.page === ContactPageNumber && linkName === 'cta::modal::skip'
  const isConditionComponent = pageInfo.page === ExteriorPageNumber || isModalSkip
  const isConditionComponentClick = !isPageView && isConditionComponent

  const isConditionFuryTab = isConditionPage(pageInfo.page)
  const isConditionFuryTabClick = !isPageView && isConditionFuryTab && linkName === 'continue'

  if (isNextFromImage) {
    return getPageHierarchy(PAGE_NUMBER_TO_ID[ImageCapturePageNumber])
  } else if (isConditionComponentTabLoad || isConditionComponentClick || isConditionFuryTabClick) {
    return getPageHierarchy(pageInfo.conditionTab)
  } else {
    return getPageHierarchy(pageInfo && getPageId(pageInfo))
  }
}

const pushCDL = (dataLayer, landingContext, isPageView) => {
  const { offer, cookies, vehicle, pageInfo, session, replacementVehicle, contactInfo, userZipcode } = dataLayer
  const { usingLandingWebComponent } = landingContext || {}
  const isLandingPageComponent = pageInfo.page === LandingPageNumber && usingLandingWebComponent
  const commonDataLayer = {
    page: {
      hierarchy: pageHierarchy(dataLayer, isPageView),
      instanceId: session?.pageInstance,
      referrerUrl: window.location.hostname
    },
    ico: {
      offerCode: offer?.offerCode,
      optionToSell: offer?.optIn,
      entryPoint: cookies?.lnx,
      path: pageInfo?.path,
      vehicleEntry: vehicle?.entry
    },
    peSnapshotId: '',
    vehicle: {
      make: vehicle?.makeName,
      model: vehicle?.modelName,
      trim: vehicle?.trimName,
      year: vehicle?.yearId,
      vin: vehicle?.vin?.toUpperCase()
    },
    client: {
      svocId: offer?.dealerId
    },
    product: {
      name: `ico-${pageInfo?.experience}`
    },
    user: {
      zipCode: userZipcode
    },
    search: {
      zipCode: ''
    }
  }

  if (isLandingPageComponent) {
    commonDataLayer.application = {
      name: `ico-${pageInfo?.experience}`,
      componentId: 'CI0445770'
    }
  }

  const consumerMetadata = encodeConsumerMetadata(contactInfo)
  if (consumerMetadata) {
    commonDataLayer.search['zipCode'] = contactInfo.zip
    commonDataLayer.consumerMetadata = consumerMetadata
  }

  if (pageInfo.page === CertificatePageNumber) {
    const { make = '', model = '', maxYear = '', minYear = '', types = [] } = replacementVehicle
    commonDataLayer.voi = { make, model, maxYear, minYear, type: types.join(',') }
    commonDataLayer.ico.offerId = offer?.offerId
  }

  return commonDataLayer
}

const encodeConsumerMetadata = contactInfo => {
  const { firstName, lastName, email: emailAddress, zip: userEntryZipCode, phone: phoneNumber, consumerId: myConsumerId } = contactInfo || {}
  const consumerMetadata = {
    firstName,
    lastName,
    emailAddress,
    userEntryZipCode,
    phoneNumber,
    myConsumerId
  }
  const nonNullMetadata = pickBy(consumerMetadata, value => value)
  return Object.keys(nonNullMetadata).length > 0 ? window.btoa(JSON.stringify(nonNullMetadata)) : null
}

export { resetCDL, pushCDL, encodeConsumerMetadata }
